// extracted by mini-css-extract-plugin
module.exports = {"slide":"DetailOrdersHotel_slide_2jXYr","slide-reverse":"DetailOrdersHotel_slide-reverse_3FzhG","order-expanded":"DetailOrdersHotel_order-expanded_1T2lS"};